module.exports = __webpack_public_path__ + "assets/img/complaint_state_0.b885c23a.svg";